<agm-map [zoom]="zoom"
         [streetViewControl]="streetViewControl"
         [latitude]="centerLat"
         [longitude]="centerLng"
         [zoomControl]="zoomControl"
         (mapReady)="mapReady($event)"
         [fitBounds]="mainFitBounds">
    <agm-marker [agmFitBounds]="true"
                [latitude]="lat"
                [longitude]="lng">
    </agm-marker>
    <div *ngIf="mechanicMarkerVisible">
        <agm-marker [agmFitBounds]="true"
                    [latitude]="latM"
                    [longitude]="lngM"
                    [iconUrl]="iconUrl"
                    [title]="titleM">
        </agm-marker>
    </div>
</agm-map>

